import { MobileApp } from '../libs/proto/commUnity_pb';

export const communityAppType = MobileApp.TIGA;

export const desktopMode = 4;
export const desktopModeURL = '';
